<template>
  <UInputMenu
    v-model="selected"
    :search="searchAction"
    :loading="loading"
    placeholder="Search address..."
    option-attribute="name"
    by="id"
    size="xl"
    rounded
    trailing
    :popper="{ arrow: false }"
    :ui="{ rounded: 'rounded-xl' }"
  >
  </UInputMenu>
</template>

<script setup lang="ts">
const location = useLocation();
const loading = ref(false);
const selected = ref();
const emit = defineEmits(['success']);

const { gtag } = useGtag();
const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  const userData = isAuthenticated ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  } : {
    user_name: null,
    user_phone: null,
    user_email: null
  };

const { addressText } = useAddressText(location);

async function searchAction (q: string) {
  if (q.length < 3) {
    return [];
  }
  loading.value = true;
  const response: any = await useAPIHandler('post', '/maps/location/search', {
    body: { text: q }
  });
  loading.value = false;
  const locations: any = [];
  response.data.forEach((item: string, index: number) => {
    locations.push({ id: index, name: item});
  });
  return locations;
}

watch(selected, async (newValue) => {
  if (newValue) {
    loading.value = true;
    await location.setAddressText(newValue.name, newValue.id);
    loading.value = false;
    gtag('event', 'cta_event', {
      action: 'input_text',
      cta_name: 'search your location',
      user_address: addressText.value,
      ...userData,
    });
    emit('success');
  }
})
</script>

